import React, { useState } from "react"

import EyeIcon from "../../svg/opened-eye-icon.inline.svg"
import EyeIconClosed from "../../svg/closed-eye-icon.inline.svg"

import XButtonIcon from "../../svg/x-button.inline.svg"

import FacebookLogin from "react-facebook-login"
import GoogleLogin from "react-google-login"

import axios from "../../http/axios"

import { useTranslation } from "react-i18next"

import { closeNavUser } from "../../scripts/loginMenus.js"
import Link from "gatsby-link"

const validEmailRegex = RegExp(
  /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
)

const SideNavUserSignupSection = props2 => {
  const [emailTriggered, setEmailTriggered] = useState(false)
  const [emailNotValid, setEmailNotValid] = useState(false)

  const [passwordTriggered, setPasswordTriggered] = useState(false)
  const [passwordNotValid, setPasswordNotValid] = useState(false)

  const [firstNameTriggered, setFirstNameTriggered] = useState(false)
  const [lastNameTriggered, setLastNameTriggered] = useState(false)
  const [phoneTriggered, setPhoneTriggered] = useState(false)

  const [invalidPasswordFormat, setInvalidPasswordFormat] = useState(false)

  const [notUniqueEmail, setnotUniqueEmail] = useState(false)
  const [invalidEmail, setInvalidEmail] = useState(false)
  const [invalidEmailTitle, setInvalidEmailTitle] = useState("")

  let firstNameLengthZero = firstNameTriggered ? "firstName-length-zero" : ""
  let lastNameLengthZero = lastNameTriggered ? "lastName-length-zero" : ""
  let phoneLengthZero = phoneTriggered ? "phone-length-zero" : ""

  let emailLengthZero = emailTriggered ? "email-length-zero" : ""
  let emailIsNotValid = emailNotValid ? "email-not-valid" : ""

  let passwordLengthZero = passwordTriggered ? "password-length-zero" : ""
  let passwordIsNotValid = passwordNotValid ? "password-not-valid" : ""

  let passwordFormatIsNotValid = invalidPasswordFormat
    ? "password-format-not-valid"
    : ""
  let emailAlreadyExists = notUniqueEmail ? "email-already-exists" : ""

  const handleReset = () => {
    Array.from(document.querySelectorAll("input")).forEach(
      input => (input.value = "")
    )
    setFormValues3({
      formValues: [{}],
    })
  }

  //Toggle eye
  const [passwordShown, setPasswordShown] = useState(false)
  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true)
  }

  const toggled = passwordShown ? "toggled" : ""

  const { t, i18n } = useTranslation()
  const currentLang = i18n.language

  const [formValues, setFormValues3] = useState({
    firstname: "",
    lastname: "",
    password: "",
    email: "",
    phone: "",
    languageCode: "",
  })

  const invalidPassMessage =
    "Invalid password, please make sure password length is between 8 and 32 characters with one digit and one capital letter"

  function handleSubmit(e) {
    e.preventDefault()
    axios
      .post("/accounts/register", {
        firstname: formValues.firstname,
        lastname: formValues.lastname,
        password: formValues.password,
        email: formValues.email,
        phone: formValues.phone,
        languageCode: currentLang,
      })
      .then(res => {
        handleReset()
        props2.thanksFunction()
        props2.passUserEmail(res)
      })
      .catch(error => {
        setInvalidEmailTitle(error.response.data.message)
        if (error.response.data?.message?.includes("Such email")) {
          setnotUniqueEmail(true)
        }
        if (error.response.data?.message?.includes("Invalid email")) {
          setInvalidEmail(true)
        }

        if (error.response.data?.message === invalidPassMessage) {
          setInvalidPasswordFormat(true)
        }
        if (error.response.data.errors?.Email != undefined) {
          setEmailTriggered(true)
        }
        if (error.response.data.errors?.Password != undefined) {
          setPasswordTriggered(true)
        }
        if (error.response.data.errors?.Firstname != undefined) {
          setFirstNameTriggered(true)
        }
        if (error.response.data.errors?.Lastname != undefined) {
          setLastNameTriggered(true)
        }
        if (error.response.data.errors?.Phone != undefined) {
          setPhoneTriggered(true)
        }
      })
  }

  const [formValidation, setFormValidation] = useState({
    email: null,
    password: null,
    errors: {
      email: "",
      password: "",
      firstname: "",
      lastname: "",
      phone: "",
    },
  })

  const handleInputChanges = e => {
    e.persist()
    const { name, value } = e.target
    let validationErrors = formValidation.errors

    setEmailTriggered(false)
    setPasswordTriggered(false)
    setFirstNameTriggered(false)
    setLastNameTriggered(false)
    setPhoneTriggered(false)
    setInvalidPasswordFormat(false)
    setnotUniqueEmail(false)
    setInvalidEmail(false)
    switch (name) {
      case "email":
        validationErrors.email = validEmailRegex.test(value)
          ? ""
          : "Invalid email"
        break
      case "password":
        validationErrors.password = value.length < 8 ? "Invalid password" : ""
        break
      default:
        break
    }
    setFormValidation({ errors, [name]: value })

    if (errors.email === "Invalid email") {
      setEmailNotValid(true)
    } else {
      setEmailNotValid(false)
    }

    if (errors.password === "Invalid password") {
      setPasswordNotValid(true)
    } else {
      setPasswordNotValid(false)
    }

    setFormValues3(currValues => ({
      ...currValues,
      [e.target.name]: e.target.value,
    }))
  }

  const responseGoogle = () => {
    console.log("Error happened")
  }

  const sendToken = response => {
    axios.post("/auth/login/google", { idToken: response.tokenId })
  }

  const sendTokenFb = response => {
    axios.post("/auth/login/facebook", { accessToken: response.accessToken })
  }

  const { errors } = formValidation
  return (
    <div
      className="side-nav-user-wrapper user-sign-up"
      id="side-nav-user-wrapper"
    >
      <div className="side-nav-user-top sign-up ps-5">
        <div className="f-ac f-js f-1">
          <div className="sign-up-btn f-ac">
            <div
              className="x-button-wrapper f-ac f-jc curs-P"
              onClick={closeNavUser}
            >
              <XButtonIcon className="x-button" />
            </div>
            <div className="sign-up-text">{t("main.header.userSignUp")}</div>
          </div>
        </div>
        <div className="f-ac f-je f-1 right-side">
          <div className="side-nav-user-right-item item-having-acc">
            {t("main.header.haveAccount")}
          </div>
          <div
            id="back"
            className="side-nav-user-right-item item-sign-up closebtn icon_button log-in-btn"
            onClick={props2.backFunction2}
          >
            {t("main.header.logIn")}
          </div>
        </div>
      </div>
      <div className="container">
        <div className="side-nav-user-info user-sign-up px-12">
          <form onSubmit={handleSubmit} noValidate>
            <div className="login-with-wrapper">
              <div className="form-field google-login">
                <div className="google-logo social-item"></div>

                <GoogleLogin
                  clientId="471557542326-t76d89ta3silnmulm38ok69cf9vflgae.apps.googleusercontent.com"
                  render={renderProps => (
                    <div
                      className="google-text social-item"
                      onClick={renderProps.onClick}
                      disabled={renderProps.disabled}
                    >
                      {t("main.header.signUpGoogle")}
                    </div>
                  )}
                  onSuccess={sendToken}
                  onFailure={responseGoogle}
                  cookiePolicy={"single_host_origin"}
                />
              </div>
              <div className="form-field facebook-login">
                <div className="facebook-logo social-item"></div>
                <FacebookLogin
                  scope="public_profile, email"
                  appId="1004871576975657"
                  callback={sendTokenFb}
                  textButton={t("main.header.signUpFacebook")}
                  render={renderProps => (
                    <button
                      className="facebook-text social-item"
                      onClick={renderProps.onClick}
                    >
                      {t("main.header.signUpFacebook")}
                    </button>
                  )}
                />
              </div>
            </div>
            <div className="form-field login-or">
              <div className="line-item"></div>
              <div className="text-item-or">{t("main.header.or")}</div>
              <div className="line-item"></div>
            </div>
            <div className="input-group">
              <input
                type="text"
                name="firstname"
                className={`form-field ${firstNameLengthZero}`}
                required
                value={formValues.firstname}
                onChange={handleInputChanges}
                placeholder={t("main.header.firstName")}
              />

              {errors.firstname.length === 0 && (
                <span
                  className={`error firstName-validation ${firstNameLengthZero}`}
                >
                  {t("main.header.firstNameRequired")}
                </span>
              )}
            </div>
            <div className="input-group">
              <input
                type="text"
                name="lastname"
                className={`form-field ${lastNameLengthZero}`}
                required
                value={formValues.lastname}
                onChange={handleInputChanges}
                placeholder={t("main.header.lastName")}
              />

              {errors.lastname.length === 0 && (
                <span
                  className={`error lastName-validation ${lastNameLengthZero}`}
                >
                  {t("main.header.lastNameRequired")}
                </span>
              )}
            </div>
            <div className="input-group special-group d-flex flex-column">
              <input
                className={`form-field ${emailIsNotValid} ${emailLengthZero} ${emailAlreadyExists}`}
                type="email"
                name="email"
                required
                placeholder={t("main.header.email")}
                value={formValues.email}
                onChange={handleInputChanges}
                noValidate
              />

              {notUniqueEmail && (
                <span className="error">{t("main.header.notUniqueMail")}</span>
              )}

              {errors.email.length !== 0 && (
                <span className="error">{t("main.header.ivalidEmail")}</span>
              )}
              {errors.email.length === 0 && (
                <span className={`error email-validation ${emailLengthZero}`}>
                  {t("main.header.emailRequired")}
                </span>
              )}
            </div>
            <div className="password-input-groups-wrapper">
              <div className="input-group special-group d-flex flex-column">
                <input
                  id="password"
                  className={`form-field ${passwordIsNotValid} ${passwordLengthZero} ${passwordFormatIsNotValid}`}
                  type={passwordShown ? "text" : "password"}
                  name="password"
                  required
                  value={formValues.password}
                  onChange={handleInputChanges}
                  placeholder={t("main.header.password")}
                />
                {/* <label>{t("main.header.password")}</label> */}

                {passwordFormatIsNotValid && (
                  <span className="error">
                    {t("main.header.passFormatError")}
                  </span>
                )}

                {errors.password.length > 0 && (
                  <span className="error">
                    {t("main.header.ivalidPassword")}
                  </span>
                )}

                {errors.password.length === 0 && (
                  <span
                    className={`error password-validation ${passwordLengthZero}`}
                  >
                    {t("main.header.passwordRequired")}
                  </span>
                )}
              </div>
              <EyeIcon
                className={`password-eye ${toggled}`}
                id="togglePassword"
                onClick={togglePasswordVisiblity}
              />
              <EyeIconClosed
                className={`password-eye crossed-eye-icon ${toggled}`}
                id="togglePassword"
                onClick={togglePasswordVisiblity}
              />
            </div>
            <div className="input-group d-flex flex-column">
              <input
                type="tel"
                name="phone"
                className={`form-field ${phoneLengthZero}`}
                required
                value={formValues.phone}
                onChange={handleInputChanges}
                placeholder={t("main.header.phone")}
              />

              {errors.phone.length === 0 && (
                <span className={`error phone-validation ${phoneLengthZero}`}>
                  {t("main.header.phoneRequired")}
                </span>
              )}
            </div>
            <div style={{ marginTop: "50px" }}>
              {invalidEmail && (
                <h3 className="style-errors-email">{invalidEmailTitle}</h3>
              )}
              <button
                id="create-acc-btn"
                className="form-field login-button login-button-margin"
                type="submit"
              >
                {t("main.header.createAccount")}
              </button>
            </div>

            <div className="term-policy-wrapper f-ac">
              <div className="agree-sas">
                {t("main.header.clickingSAS")}{" "}
                <Link to={`/${currentLang}/privacy`}>
                  {" "}
                  <span className="curs-P terms-policy-item">
                    {t("main.header.termsConditions")}
                  </span>{" "}
                </Link>{" "}
                {t("main.header.and")}{" "}
                <Link to={`/${currentLang}/terms`}>
                  {" "}
                  <span className="curs-P terms-policy-item">
                    {t("main.header.privacyPolicy")}
                  </span>
                </Link>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default SideNavUserSignupSection
